import { ValidationStrategyFactory } from "./validation-strategy.factory";
import { ValidationStrategy } from "./validation.strategy";

export class SwitchContainerValidationStrategy extends ValidationStrategy {

    get isChecked(): boolean {
        if(!this.attribute.value) {
            return false;
        }
        
        return this.attribute.value.toLowerCase() == "true";
    }

    public validate(): boolean {
        if(!this.isChecked) {
            return true
        }

        let isValid = true;

        this.attribute.attributes.forEach(childAttribute => {
            let validator = ValidationStrategyFactory.create(childAttribute, this.injectedOptions);
            let isValidChild = validator.validate();
            isValid = isValidChild && isValid;
        });

        return isValid
    }
}